import { _axios } from '@/plugins/axios';

const inScopeRequirementsResource = '/api/v1/in-scope-requirements';

export default {
  all: socId => _axios.get(`${inScopeRequirementsResource}/all/${socId}`),
  getScores: () => _axios.get(`${inScopeRequirementsResource}/scores`),
  update: req => _axios.put(`${inScopeRequirementsResource}/update`, req),
};
